import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { onResponseCreateCorp } from "./helpers";

const createCorp = async (data: CreateCorpReqT) => {
  return axios.post(Routes.CREATE_CORP, data);
};

export const useCreateCorp = () =>
  useMutation({
    mutationKey: [Keys.CREATE_CORP],
    mutationFn: createCorp,
    onSettled: onResponseCreateCorp,
    cacheTime: Infinity,
  });
